import {useFormContext} from '@yandex-delivery/form'
import {useCallback, useState} from 'react'

import {OrderEventGoal, useFormUserEventHandler} from 'src/shared/hooks'
import {orderPath} from 'src/shared/utils'

import {BUSINESS_PARCEL_SIZES} from './consts'
import type {GetParcelSizes, Props} from './types'
import {isParcelSize} from './utils'

export function useParcel(getParcelSizes: GetParcelSizes, props: Props) {
  const {watch, setFieldValue} = useFormContext()
  const [isBannerVisible, setIsBannerVisible] = useState(false)
  const [isCustomSizeOpened, setIsCustomSizeOpened] = useState(false)
  const handleReachGoal = useFormUserEventHandler()

  const selectedParcelSize = watch(orderPath(`${props.name}.size`))
  const isBusiness = watch(orderPath('isBusiness'))
  const parcelSizes = getParcelSizes(selectedParcelSize, isBusiness)

  const customSizeVisibilityHandler = useCallback(() => {
    setIsCustomSizeOpened(prevState => !prevState)
  }, [])

  const toggleBannerVisibilityHandler = useCallback(() => {
    setIsBannerVisible(prevState => !prevState)
  }, [])

  const sizeSetHandler = useCallback(
    (size: string) => {
      if (BUSINESS_PARCEL_SIZES.includes(size)) {
        toggleBannerVisibilityHandler()
        handleReachGoal(OrderEventGoal.B2BXXLSizeClick)
        return
      }

      if (isParcelSize(size)) {
        setFieldValue(`${props.name}.size`, size)
        handleReachGoal(OrderEventGoal.ShipmenSizeClick)
      }
    },
    [handleReachGoal, props.name, setFieldValue, toggleBannerVisibilityHandler],
  )

  function selectSegmentHandler() {
    handleReachGoal(OrderEventGoal.SegmentClick)
  }

  function bannerActionButtonClickHandler() {
    handleReachGoal(OrderEventGoal.BannerXXLSizeButtonClick)
  }

  return {
    isBusiness,
    parcelSizes,
    isCustomSizeOpened,
    customSizeVisibilityHandler,
    sizeSetHandler,
    selectedParcelSize,
    isBannerVisible,
    toggleBannerVisibilityHandler,
    selectSegmentHandler,
    bannerActionButtonClickHandler,
  } as const
}
